import { useContext } from 'react'
import { TopDestinationsContext } from 'src/context/topDestinations'
import { TopDestinationsType } from 'src/types/topDestinations'

export function useTopDestinations(): TopDestinationsType {
  const value = useContext(TopDestinationsContext)

  if (!value) {
    throw new Error('Missing TopDestinationsContext provider')
  }

  return value
}
